import React from 'react';
import { Button, Grid } from 'ui-toolkit';
import { useFormikContext } from 'formik';

export interface ISideSheetFormFooterProps {
  saveButtonText: 'Save and Add' | 'Save and Update' | 'Save' | 'Send';
  onCancel: () => void;
}

export const SideSheetFormFooter: React.FC<ISideSheetFormFooterProps> = ({ onCancel, saveButtonText }) => {
  const { dirty, isValid } = useFormikContext();
  const isDisabled = !isValid || !dirty;
  return (
    <Grid columnCount={2}>
      <Button data-test-id={'side-sheet-footer-cancel-btn'} intent="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button data-test-id={'side-sheet-footer-submit-btn'} intent="primary" type="submit" disabled={isDisabled}>
        {saveButtonText}
      </Button>
    </Grid>
  );
};
